import { useAuthentication, useUserInfo } from "@today/auth"
import { Button } from "baseui/button"
import router from "next/router"
import { PropsWithChildren } from "react"
import { Container } from "../../incheon/Container"

type CheckAlreadyRegisterProps = {
  type: "signup" | "configure"
} & PropsWithChildren<{}>

function CheckAlreadyRegister({ children, type }: CheckAlreadyRegisterProps) {
  const { logout } = useAuthentication()
  const { name: clientName, isAuthenticated, clientRoles } = useUserInfo()
  const hasTemporaryRole = clientRoles.includes("incheon:temporary")

  if (!isAuthenticated || (hasTemporaryRole && type === "configure")) {
    return <Container>{children}</Container>
  }

  return (
    <Container>
      {type === "signup" ? (
        <AlreadySignup clientName={clientName} logout={logout} />
      ) : (
        <AlreadyConfigured clientName={clientName} />
      )}
    </Container>
  )
}

export default CheckAlreadyRegister

type AlreadyRegisterProps = {
  clientName: string
  logout: () => void
}
function AlreadySignup({ clientName, logout }: AlreadyRegisterProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center text-2xl">
      <p className="text-3xl">
        <span className="font-bold">{clientName}</span>님,
      </p>
      <p className="mt-2">이미 가입 및 로그인 된 상태입니다.</p>
      <Button className="mt-12" onClick={() => router.replace("/orders")}>
        주문 페이지로 이동하기
      </Button>
      <Button className="mt-4" kind="secondary" onClick={() => logout()}>
        로그아웃 하기
      </Button>
    </div>
  )
}

function AlreadyConfigured({
  clientName,
}: Pick<AlreadyRegisterProps, "clientName">) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center text-2xl">
      <p className="text-3xl">
        <span className="font-bold">{clientName}</span>님,
      </p>
      <p className="mt-2">이미 고객 정보를 설정하였습니다.</p>
      <Button className="my-12" onClick={() => router.replace("/orders")}>
        주문 페이지로 이동하기
      </Button>
    </div>
  )
}
